var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.832 1.252H1.83h1.222v1.221c0 1.65 2.504 1.65 2.504 0V1.252h4.885v1.221c0 1.65 2.443 1.65 2.443 0V1.252h1.222c1.038 0 1.893.854 1.893 1.831v11.054c0 1.037-.855 1.831-1.893 1.831H1.832A1.837 1.837 0 010 14.137V3.083c0-.976.854-1.831 1.832-1.831zM1.22 5.527v8.61c0 .367.305.611.61.611h12.275c.367 0 .61-.244.61-.61V5.527H1.222zM11.053.64c0-.794 1.222-.794 1.222 0v1.832c0 .794-1.222.794-1.222 0V.64zm-7.389 0c0-.794 1.222-.794 1.222 0v1.832c0 .794-1.222.794-1.222 0V.64z",
    fillRule: "evenodd"
  })));
}
export default SvgCalendar;